import type { Router, RouteLocationNormalizedLoadedGeneric } from 'vue-router';
import { enc, encData } from '@/utils/http/axios';
import { ReportType } from '@/hooks/types';
import { showToast } from 'vant';
import { UserInfo } from '@/store';
import router from '@/router';

// 校验手机号码
export const checkPhone = (phone: string) => /^1[3456789]\d{9}$/.test(phone);
// /^1\d{10}$|^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/.test(phone);

// 校验身份证号码
export const checkIdCard = (idCard: string) =>
  /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(idCard);

// 校验验证码
export const checkCode = (code: string) => /^\d{4,6}$/.test(code);

// 解析url的query参数(类似格式的数据都可以)
// 格式：id=&reportType=
export const formateQuery = (queryStr: string) => {
  if (!queryStr) return;
  return queryStr.split('&').reduce((acc, par) => {
    const [key, val] = par.split('=');
    acc[key] = val;
    return acc;
  }, {} as Record<string, any>);
};

// 获取 linkId 相关 param
export const getLinkIdParam = (route: RouteLocationNormalizedLoadedGeneric) => {
  if (!route.query.param) {
    return { ...route.query, reportType: route.query.type || 1 } as Record<string, any>;
  }

  try {
    // 有 param → 走解密逻辑
    const param = decodeURIComponent(route.query.param as string);
    const decryptedStr = enc(param);
    const formatedParam = formateQuery(decryptedStr) || {};
    return formatedParam;
  } catch (err) {
    // 解析失败 → 兜底返回原始 query
    return { ...route.query, reportType: route.query.type || 1 } as Record<string, any>;
  }
  // const param = decodeURIComponent(route.query.param as string); // 加密后的参数
  // if (!param) return;
  // const formatedParam = formateQuery(enc(param)) || {};
  // // if (!formatedParam.id) return;\
  // return formatedParam;
};

// 校验两位数金额
export const checkTwoPrecision = (val: string | number) => {
  if (val === undefined || val === null) return false;
  return /^(\d+.\d{1,2}|\d+)$/.test(`${val}`);
};

/**
 * 检查浏览器环境
 * qq：qq环境
 * wechat：微信环境
 * alipay：支付宝环境
 * apple：苹果环境
 */
export const checkBrowserEnv = (envStr: 'qq' | 'wechat' | 'alipay' | 'apple') => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  console.log(555999, navigator, userAgent);
  const envRegArr: Record<typeof envStr, { testArr: string[]; checkAll?: boolean }> = {
    qq: { testArr: ['qq/', 'qqtheme'], checkAll: true },
    wechat: { testArr: ['wechat', 'weixin', 'micromessenger'] },
    alipay: { testArr: ['alipay'] },
    apple: { testArr: ['iphone', 'ipad', 'ipod'] },
  };
  const curRegArr = envRegArr[envStr];

  return (
    curRegArr &&
    curRegArr.testArr[curRegArr.checkAll ? 'every' : 'some']((item) => userAgent.indexOf(item) > -1)
  );
};

/**
 * 自动检测当前浏览器环境
 * @returns 'wechat' | 'qq' | 'alipay' | 'apple' | 'other'
 */
export const getCurrentBrowserEnv = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  // 优先级：微信 > QQ > 支付宝 > 苹果设备 > 其他
  if (/micromessenger|wechat|weixin/.test(userAgent)) {
    return 'weixin';
  }
  if (/qq\/|qqtheme/.test(userAgent)) {
    return 'qq';
  }
  if (/alipay/.test(userAgent)) {
    return 'alipay';
  }
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return 'apple';
  }
  return 'browser';
};

// 检查是否为苹果设备
export const checkIsApple = () => {
  const userAgent = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(userAgent);
};
// var browser = {
//   version: function () {
//     var u = navigator.userAgent;
//     var ua = navigator.userAgent.toLocaleLowerCase();
//     var app = navigator.appVersion;
//     return {
//       trident: u.indexOf('Trident') > -1, // IE内核
//       presto: u.indexOf('Presto') > -1, // opera内核
//       webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
//       gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
//       mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
//       ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // IOS终端
//       android: u.indexOf('Android') > -1 || u.indexOf('Mac') > -1, // 安卓终端
//       iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iphone或QQHD浏览器
//       iPad: u.indexOf('iPad') > -1, // 是否为iPad
//       webApp: u.indexOf('Safari') == -1, // 是否web应用程序，没有头部与底部
//       QQbrw: u.indexOf('MQQBrowser') > -1, // QQ浏览器
//       weiXin: u.indexOf('MicroMessenger') > -1, // 微信
//       QQ: ua.match(/QQ/i) == "qq", // QQ
//       weiBo: ua.match(/WeiBo/i) == "weibo", // 微博
//       ucLowEnd: u.indexOf('UCWEB7.') > -1, //
//       ucSpecial: u.indexOf('rv:1.2.3.4') > -1,
//       webview: !(u.match(/Chrome\/([\d.]+)/) || u.match(/CriOS\/([\d.]+)/)) && u.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/),
//       ucweb: function () {
//         try {
//           return parseFloat(u.match(/ucweb\d+\.\d+/gi).toString().match(/\d+\.\d+/).toString()) >= 8.2
//         } catch (e) {
//           if (u.indexOf('UC') > -1) {
//             return true;
//           }
//           return false;
//         }
//       }(),
//       Symbian: u.indexOf('Symbian') > -1,
//       ucSB: u.indexOf('Firofox/1.') > -1
//     };
//   }()
// };
// 检测是否为微信环境
export const checkIsWechat = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  console.log(555999, navigator, userAgent);
  // 微信浏览器
  const wechatFlag = ['wechat', 'weixin', 'micromessenger'];
  for (let i = 0, len = wechatFlag.length; i < len; i++) {
    if (userAgent.includes(wechatFlag[i])) {
      return true;
    }
  }
  return false;
};

// 检查是否为QQ内部的浏览器
export const checkIsQQApp = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  // const qqBrowserSigns = ['qqbrowser', 'qq/', 'mqqbrowser'];
  const qqBrowserSigns = ['qq/', 'qqtheme'];
  return qqBrowserSigns.every((item) => userAgent.indexOf(item) > -1);
};

export const testPhone = (val: string) => {
  if (!val) {
    return false;
  }
  const reg = /^1(3[0-9]|4[5-9]|5[0-3,5-9]|6[2,5,6,7]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
};
export const testIdCard = (val: string) => {
  if (!val) {
    return false;
  }
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
};
export const testName = (val: string) => {
  if (!val) return false;
  const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d]{2,20}$/;
  return reg.test(val);
};

export const testCode = (val: string) => {
  if (!val) {
    return false;
  }
  const reg = /^[0-9]\d*|0$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
};

// 校验银行卡号
export const checkBankcard = (value: string) => {
  return /^\d{16,19}$/.test(value);
};

// 校验带一个点的汉字名字
export const checkChineseAndDot = (value: string) => /^[\u4e00-\u9fa5·]+$/.test(value);

// 删除所有空格
export const delSpace = (value: string) => value.replace(/\s+/g, '');

// base2Blob
export const base64ToBlob = (code: string) => {
  const dataBin = window.atob(code.split(',')[1]);
  const rawLength = dataBin.length;
  const buffer = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; i++) {
    buffer[i] = dataBin.charCodeAt(i);
  }

  const matches = code.match(/^data:([\w/\-+]+)(;base64)?,(.+)$/);
  console.log({ matches, split: code.split(';base64,') });

  return new window.Blob([buffer.buffer], {
    type: code.split(';base64,')[0].split(':')[1],
  });
};

// 校验数字和英文
export const verifyLetterNum = (value: string) => /^[A-Za-z0-9]+$/.test(value);

// 加密的query
export const encRouteQuery = (data: string | number | Record<string, string | number>) => {
  const dataType = typeof data;
  return encodeURIComponent(
    dataType === 'number' || dataType === 'string' ? data.toString() : encData(JSON.stringify(data))
  );
};

// 判断是否为全英文
export const checkIsAllLetter = (value: string) => /^[a-zA-Z]+$/.test(value);
// 路由跳转报告详情
export const toReportDetail = (
  router: Router,
  reportType: number,
  params: {
    reportId: number | string;
    serialNumber: string;
    disableFeedback?: 0 | 1;
    enabledShare?: 0 | 1;
  }
) => {
  router.push({
    path: `/reportDetailNew/${reportType}`,
    query: { params: encodeURIComponent(encData(JSON.stringify(params))) },
  });
};
export const toReportDetailPlain = (
  router: Router,
  reportType: number,
  params: {
    reportId: number | string;
    serialNumber: string;
    disableFeedback?: 0 | 1;
    enabledShare?: 0 | 1;
    siteType?: string;
  }
) => {
  if (!params.siteType) {
    return;
  }
  router.push({
    path: `/reportDetailNew/${reportType}`,
    query: { serialNumber: params.serialNumber, siteType: params.siteType },
  });
};

// 判断是否为代理人
export const checkIsAgent = (data: {
  loginInfo: Partial<UserInfo>;
  router: Router;
  routerJump?: true;
}) => {
  const { loginInfo, router, routerJump = true } = data;
  if (!loginInfo.id) return;
  if (Number(loginInfo.isAgent) !== 1) {
    if (Number(loginInfo.reviewStatus) === 0) {
      return !showToast('代理人注册审核中');
    } else {
      return !showToast({
        message: '请先注册成为代理',
        onClose() {
          routerJump && router.push({ path: '/agentsMaterial' });
        },
      });
    }
  }
  return true;
};

// 获取随机数 [min, max)
export const getRandomNum = (max = 9, min = 0) => Math.floor(Math.random() * (max - min)) + min;

// 获取随机手机号
export const getRandomPhone = () => {
  const phonePrefix = ['135', '136', '137', '138', '139', '155', '156', '158'];
  return `${phonePrefix[getRandomNum(phonePrefix.length)]}****${getRandomNum(10)}${getRandomNum(
    10
  )}${getRandomNum(10)}${getRandomNum(10)}`;
};

// 客服电话
export const CustomerServicePhone = '4006565013';

/**
 * 跳转留资页面
 * mode：
 *   realName：实名，需要展示上传图片
 */
export const toAgentMaterial = ({ mode }: { mode?: 'realName' } = {}) =>
  router.push({
    name: 'agentsMaterial',
    query: { mode },
  });

/**
 * 检查支付环境是否合法
 * payType：
 *  1：微信
 *  2：支付宝
 *  3：上海汇付支付宝H5
 *  4：上海汇付微信H5
 *  6：联联微信支付
 *  7：联联支付宝
 *  8：微信 - 新
 */
export const checkPayEnv = (payType: number, option: { invalidCb: () => void }) => {
  if (payType === undefined || payType === null) return;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const { invalidCb = () => {} } = option || {};
  if (
    // QQ App 的浏览器
    checkBrowserEnv('qq') ||
    // 微信原生检测到风险不能在微信内打开
    (payType === 8 && (checkBrowserEnv('alipay') || checkBrowserEnv('wechat')))
  ) {
    invalidCb();
    return false;
  }
  if ([1, 4, 6].includes(payType)) {
    // 支付宝环境的微信支付
    if (checkBrowserEnv('alipay')) {
      invalidCb();
      return false;
    }
  } else {
    // 微信环境的支付宝支付
    if (checkBrowserEnv('wechat')) {
      invalidCb();
      return false;
    }
  }

  return true;
};

// 脱敏方法：隐藏姓名的中间部分
export const desensitizeName = (name: string): string => {
  if (!name || name.length === 0) return '';
  if (name.length === 1) return name; // 如果只有一个字符，直接返回
  if (name.length === 2) return name[0] + '*'; // 两个字符时，显示第一个字符和 *
  if (name.length === 3) return name[0] + '*' + name[2]; // 3个字符时，显示第一个字符和 最后一个*
  // 对于更长的姓名，显示第一个字符和剩余字符用 * 替换
  return name[0] + '*'.repeat(name.length - 1);
};
